// Single source of truth for what each subscription plan unlocks in the dashboard.
// Plan types in the DB are normalized to starter / professional / growth (see
// backend migrate-plan-types.ts). Aliases (basic, basic_plus_content, legacy pro)
// are folded in here so callers never have to know about them.

export type PlanTier = 'starter' | 'professional' | 'growth';

export function normalizePlan(planType?: string | null): PlanTier {
  switch (planType) {
    case 'professional':
      return 'professional';
    case 'growth':
    case 'basic_plus_content':
    case 'pro': // legacy Pro → full access
      return 'growth';
    default: // starter, basic, undefined
      return 'starter';
  }
}

export interface PlanFeatures {
  seo: boolean;
  bookingsEnable: boolean; // can turn online booking ON (the page is always visible)
  autoContent: boolean;    // automated content posting (Professional+). Starter gets a
                           // setup/maintenance roadmap instead, not auto-posting.
}

export const PLAN_FEATURES: Record<PlanTier, PlanFeatures> = {
  starter: { seo: false, bookingsEnable: false, autoContent: false },
  professional: { seo: true, bookingsEnable: true, autoContent: true },
  growth: { seo: true, bookingsEnable: true, autoContent: true },
};

export function getPlanFeatures(planType?: string | null): PlanFeatures {
  return PLAN_FEATURES[normalizePlan(planType)];
}
